/**
 * siteMode.js — global pre-harvest flag.
 *
 * PRE_HARVEST_MODE = true  → no purchases; waitlist CTA everywhere; prices hidden.
 * PRE_HARVEST_MODE = false → normal e-commerce mode.
 *
 * Flip to false when the harvest is in and stock is restocked via admin panel.
 */
export const PRE_HARVEST_MODE = true;
